import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig } from '@angular/material';

@Component({
  selector: 'plrConfirmationDialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

  @ViewChild('message')
  messageElementRef: ElementRef;

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
    }

  ngOnInit() {
    if(this.data.local) {
      const matDialogConfig: MatDialogConfig = new MatDialogConfig();
      const rect = (this.data.local.elementRef as ElementRef).nativeElement.getBoundingClientRect();
      const dialogRect = (this.dialogRef._containerInstance as any)._elementRef.nativeElement.getBoundingClientRect();
      if(!this.data.local.position || this.data.local.position === 'left'){
        matDialogConfig.position = { left: `${rect.left - dialogRect.width}px`, top: `${rect.top - dialogRect.height}px` };
      } else if(this.data.local.position === 'right'){
        matDialogConfig.position = { left: `${rect.right}px`, top: `${rect.top - dialogRect.height}px` };
      }  else if(this.data.local.position === 'top'){
        var offset = (dialogRect.width - rect.width) / 2;
        matDialogConfig.position = { left: `${rect.left - offset}px`, top: `${rect.top + dialogRect.height}px` };
      }   else if(this.data.local.position === 'bottom'){
        var offset = (dialogRect.width - rect.width) / 2;
        matDialogConfig.position = { left: `${rect.left - offset}px`, top: `${rect.bottom}px` };
      } 
      this.dialogRef.updatePosition(matDialogConfig.position);
    }
  }

  ok(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/common/components/confirmation-dialog.component.ts